__turbopack_context__.v({
  "accordionSlideOverwrite": "termSheetPreviewGroup-module-scss-module__v56qAa__accordionSlideOverwrite",
  "boldFieldLabel": "termSheetPreviewGroup-module-scss-module__v56qAa__boldFieldLabel",
  "fadeIn": "termSheetPreviewGroup-module-scss-module__v56qAa__fadeIn",
  "fadeOut": "termSheetPreviewGroup-module-scss-module__v56qAa__fadeOut",
  "fieldRow": "termSheetPreviewGroup-module-scss-module__v56qAa__fieldRow",
  "fieldTopDivider": "termSheetPreviewGroup-module-scss-module__v56qAa__fieldTopDivider",
  "fields": "termSheetPreviewGroup-module-scss-module__v56qAa__fields",
  "header": "termSheetPreviewGroup-module-scss-module__v56qAa__header",
  "label": "termSheetPreviewGroup-module-scss-module__v56qAa__label",
  "scaleIn": "termSheetPreviewGroup-module-scss-module__v56qAa__scaleIn",
  "scaleOut": "termSheetPreviewGroup-module-scss-module__v56qAa__scaleOut",
  "skeleton": "termSheetPreviewGroup-module-scss-module__v56qAa__skeleton",
  "termSheetPreviewGroup": "termSheetPreviewGroup-module-scss-module__v56qAa__termSheetPreviewGroup",
  "title": "termSheetPreviewGroup-module-scss-module__v56qAa__title",
  "value": "termSheetPreviewGroup-module-scss-module__v56qAa__value",
  "zoomIn": "termSheetPreviewGroup-module-scss-module__v56qAa__zoomIn",
  "zoomOut": "termSheetPreviewGroup-module-scss-module__v56qAa__zoomOut",
});
